import { render } from "./HomeDestaques.vue?vue&type=template&id=42164d37&scoped=true"
import script from "./HomeDestaques.vue?vue&type=script&lang=js"
export * from "./HomeDestaques.vue?vue&type=script&lang=js"

import "./HomeDestaques.vue?vue&type=style&index=0&id=42164d37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42164d37"]])

export default __exports__